import { trackError } from '@iheartjane/tracking';

/** Takes a file and converts to an image if input is a pdf */
export const convertIfPDF = async function (file: string): Promise<string> {
  if (!file.includes('application/pdf')) {
    // if the file is not a PDF, return for backend processing
    return file;
  }

  try {
    // Defer importing pdfjs-dist until it is actually in use.
    const [{ GlobalWorkerOptions, getDocument }, { default: workerUrl }] =
      await Promise.all([
        import('pdfjs-dist'),
        /** Continue using legacy build for the oldest of our supported browsers. */
        import('pdfjs-dist/legacy/build/pdf.worker.min.mjs?url'),
      ]);
    GlobalWorkerOptions.workerSrc = workerUrl;

    const pdf = await getDocument({ url: file }).promise;
    const page = await pdf.getPage(1);
    const viewport = page.getViewport({ scale: 1.5 });

    const canvas: HTMLCanvasElement = document.createElement('canvas');
    canvas.height = viewport.height;
    canvas.width = viewport.width;

    await page.render({
      canvas,
      viewport,
    }).promise;

    return canvas.toDataURL('image/jpeg');
  } catch (e) {
    trackError('Unable to convert PDF', {
      e,
      file: file.slice(0, 100),
    });
    throw new Error(
      'Unable to process this PDF. Please choose a different image.'
    );
  }
};
